<template>
  <div>
    <cooperation-search-head
      :titleInfo="titleInfo"
      :bgUrl="bgUrl"
      @handSearch="handSearch"
      :companyList="companyList"
      :showDropSelect="true"
    >
    </cooperation-search-head>
    <div class="cooperation-pay-index-container">
      <div class="pay-content-head">
        <cooperation-title-cp
          title="请款概览"
          :bg="false"
        ></cooperation-title-cp>
        <div class="report-title">
          <div class="left">
            <p>
              累计请款金额： <span>{{ body.adRequestfund | money2 }}</span>
            </p>
            <p>
              累计发票金额： <span>{{ body.ljinvoiceamount | money2 }}</span>
            </p>
            <p>
              累计收款金额： <span>{{ body.htljsfamount | money2 }}</span>
            </p>
          </div>
          <div class="right">
            <p>
              本月请款金额： <span>{{ body.cmRequestfund | money2 }}</span>
            </p>
            <p>
              本月发票金额： <span>{{ body.cmInvoiceamount | money2 }}</span>
            </p>
            <p>
              本月收款金额： <span>{{ body.cmBcljsfamount | money2 }}</span>
            </p>
          </div>
        </div>
      </div>
      <div class="pay-body-content">
        <cooperation-title-cp
          title="我的付款申报"
          :bg="false"
        ></cooperation-title-cp>
        <van-list
          :offset="30"
          v-model="loading"
          :finished="finished"
          :immediate-check="false"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <van-cell v-for="(item, index) in list" :key="index">
            <template>
              <div class="mine-item">
                <mine-pay-change :item="item"></mine-pay-change>
                <div class="mine-item-bg"></div>
              </div>
            </template>
          </van-cell>
        </van-list>
      </div>
    </div>
  </div>
</template>

<script>
import cooperationTitleCp from '../components/title-cp';
import minePayChange from './cooperation-packge/components/cooperation-my-pay-change-cp';
import cooperationSearchHead from './cooperation-packge/components/cooperation-search-head-cp';

import { List, PullRefresh, Sticky } from 'vant';
import { getUrlParams } from 'common/js/mUtils';

export default {
  name: 'cooperation-pay-index',

  data() {
    return {
      body: {},
      list: [],
      loading: true,
      finished: false,
      refreshing: false,
      current: 1,
      size: 10,
      providerGuid: '',
      companyList: [],
      params: {},
      titleInfo: {
        selectname: '申报日期',
        selectTitle: '申报日期'
      },
      bgUrl: '',
      watertext: '',
      watermobile: ''
    };
  },
  created() {
    let { providerGuid, employeeName, mobile } = getUrlParams();
    this.watertext = decodeURIComponent(employeeName) || '';
    this.watermobile = mobile;
    let params = {
      providerGuid,
      current: this.current,
      size: this.size
    };
    this.providerGuid = providerGuid;

    this._getPaymentStatistics(params);
    this._getPaymentList(params);
    this._getComplay({ type: 'payment' });
    this.$api.getBannerList({ current: 1, size: 999 }).then(res => {
      let { code, body } = res;
      if (code == '0000') {
        let { records } = body;
        records = records.filter(item => item.position == 5);
        this.bgUrl = records.length && records[0].image;
      }
    });
  },
  components: {
    cooperationTitleCp,
    minePayChange,
    cooperationSearchHead,
    [Sticky.name]: Sticky,
    [List.name]: List,
    [PullRefresh.name]: PullRefresh
  },

  methods: {
    _getComplay({ type }) {
      let { providerGuid } = getUrlParams();
      this.$api
        .getCompanyList({
          providerGuid,
          type
        })
        .then(res => {
          let { status, body } = res;
          if (status) {
            this.companyList = body.map(item => {
              return {
                text: item.name,
                value: item.id
              };
            });
          }
        });
    },
    _getPaymentStatistics(params) {
      this.$api.getPaymentStatistics(params).then(res => {
        let { status, body } = res;
        if (status) {
          this.body = body;
        }
      });
    },
    _getPaymentList(params) {
      let { current, providerGuid, size } = this;
      params = { providerGuid, ...params, current, size };
      this.$api.getPaymentList(params).then(res => {
        let { status, body } = res;
        let { records } = body;
        if (status) {
          this.loading = false;
          this.refreshing = false;
          if (records.length == 0) {
            this.finished = true;
            return;
          }
          this.list = this.list.concat(records);
        }
      });
    },
    handSearch(data) {
      let params = { ...data };
      this.list = [];
      this.current = 1;
      this.params = params;
      this.loading = false;
      this.finished = false;
      this._getPaymentList(params);
    },
    onLoad() {
      this.current++;
      let { params } = this;
      this._getPaymentList(params);
    }
  }
};
</script>

<style scoped lang="scss">
.cooperation-pay-index-container {
  position: relative;
  z-index: 9;
  .pay-body-content {
    margin-top: 20px;
    /deep/ .van-cell {
      position: relative;
      display: flex;
      box-sizing: border-box;
      width: 100%;
      padding: 0px;
      overflow: hidden;
      color: #323233;
      font-size: 0.28rem;
      line-height: 1;
      background-color: transparent;
      margin-bottom: 10px;
    }
    .mine-item {
      background: transparent;
      margin-top: 10px;
      .mine-item-bg {
        background: #efefef;
        height: 10px;
      }
    }
    .mine-item:nth-child(2) {
      margin-top: 0 !important;
    }
  }
  .pay-content-head {
    margin-top: 10px;
    .report-title {
      height: 160px;
      width: 100%;
      background: transparent;
      font-size: 24px;
      display: flex;
      padding: 30px;
      .left {
        width: 50%;
        height: 110px;
        padding-right: 20px;
        overflow: hidden;
        position: relative;
        span {
          color: #000000;
          // float: right;
        }
        p {
          margin-top: 15px;
          color: #666666;
        }
        p:nth-child(1) {
          margin-top: 0;
        }
      }
      .left::after {
        position: absolute;
        right: 25px;
        height: 100px;
        border: 1px solid #efefef;
        content: '';
        top: 0px;
        transform: scaleX(0.5);
      }
      .right {
        height: 110px;
        width: 50%;
        padding-left: 20px;
        // padding-right: 40px;
        overflow: hidden;
        span {
          color: #c18858;
          // float: right;
        }
        p {
          margin-top: 15px;
        }
        p:nth-child(1) {
          margin-top: 0;
        }
      }
    }
  }
}
</style>
